import {
  HiInformationCircle as IconInfoCircle,
  HiExclamationTriangle as IconAlertTriangle,
  HiExclamationCircle as IconAlertCircle,
  HiCheckCircle as IconCircleCheck,
} from "react-icons/hi2";

/** To add a new variant, add a new entry below following the same shape. */
export const NOTIFICATION_VARIANTS = {
  info: {
    Icon: IconInfoCircle,
    iconColor: "var(--mantine-color-primary-2)",
    bg: "var(--mantine-color-primary-light)",
    mantineColor: "primary",
  },
  warning: {
    Icon: IconAlertTriangle,
    iconColor: "var(--mantine-color-warning-1)",
    bg: "var(--mantine-color-warning-1)",
    mantineColor: "warning",
  },
  error: {
    Icon: IconAlertCircle,
    iconColor: "var(--mantine-color-error-2)",
    bg: "var(--mantine-color-error-light)",
    mantineColor: "error",
  },
  success: {
    Icon: IconCircleCheck,
    iconColor: "var(--mantine-color-success-2)",
    bg: "var(--mantine-color-success-light)",
    mantineColor: "success",
  },
};
